import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { LegalGoLiveBanner } from "./LegalContactCard";

export const LegalGoLiveReminder = () => {
  const [missing, setMissing] = useState([]);
  useEffect(() => {
    api.get("/admin/legal/contact").then((r) => setMissing(r.data.missing || [])).catch(() => setMissing([]));
  }, []);
  if (!missing.length) return null;
  return (
    <div className="mt-8" data-testid="dashboard-legal-reminder">
      <LegalGoLiveBanner missing={missing} testId="dashboard-legal-banner" />
      <Link to="/admin/landing-pages#legal-pages" className="text-xs underline mt-1 inline-block" data-testid="dashboard-legal-reminder-link">
        Add them in Landing Pages → Legal pages
      </Link>
    </div>
  );
};
